import "../css/privacy.css";
import Footerlanding from '../landing/Footerlanding';
import Navbarlanding from '../landing/Navbarlanding';

    const PrivacyPolicy = () => {
    return (
        <div className="privacy-page">
        <Navbarlanding />

        <div className="terms-wrapper">
            <h1>Privacy Policy</h1>
            <p>Last updated: [Date]</p>

            <section>
            <h2>1. Introduction</h2>
            <p>
                Techvision (“we”, “us”, “our”) values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services.
            </p>
            </section>

            <section>
            <h2>2. Information We Collect</h2>
            <p>
                We may collect the following information from you:
            </p>
            <ul>
                <li>Personal information such as name, email, and contact details</li>
                <li>Usage data such as pages visited, clicks, and browsing behavior</li>
                <li>Cookies and similar tracking technologies</li>
            </ul>
            </section>

            <section>
            <h2>3. How We Use Information</h2>
            <p>
                We use your information to:
            </p>
            <ul>
                <li>Provide and improve our services</li>
                <li>Communicate with you regarding updates and offers</li>
                <li>Ensure website security and prevent fraud</li>
                <li>Comply with legal obligations</li>
            </ul>
            </section>

            <section>
            <h2>4. Information Sharing</h2>
            <p>
                We do not sell or rent your personal information. We may share your information with:
            </p>
            <ul>
                <li>Trusted service providers to operate our services</li>
                <li>Authorities when required by law</li>
            </ul>
            </section>

            <section>
            <h2>5. Cookies & Tracking</h2>
            <p>
                We use cookies to enhance user experience and track website performance. You can disable cookies in your browser settings, but some features may not function properly.
            </p>
            </section>

            <section>
            <h2>6. Security</h2>
            <p>
                We implement appropriate technical and organizational measures to protect your personal data. However, no method of transmission over the Internet is 100% secure.
            </p>
            </section>

            <section>
            <h2>7. Your Rights</h2>
            <p>
                You have the right to access, correct, or delete your personal information. You may also opt out of receiving marketing communications from us.
            </p>
            </section>

            <section>
            <h2>8. Third-Party Links</h2>
            <p>
                Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external websites.
            </p>
            </section>

            <section>
            <h2>9. Updates to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated “Last updated” date.
            </p>
            </section>

            <section>
            <h2>10. Contact Us</h2>
            <p>
                If you have any questions about this Privacy Policy, you can contact us at: <br />
                Email: info@yourdomain.com <br />
                Address: Your Company Address
            </p>
            </section>
        </div>

        <Footerlanding />
        </div>
    );
    };

    export default PrivacyPolicy;